import PropTypes from 'prop-types';

const Iframe = ({ src, className, onLoad, height }) => {
  return (
    <iframe
      align="middle"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-presentation"
      width="100%"
      height={height}
      marginHeight="0px"
      marginWidth="0px"
      hspace="0"
      vspace="0"
      frameBorder="0"
      allowFullScreen
      id="iframe-content"
      className={`iframe-content bg-white ${className}`}
      src={src}
      onLoad={onLoad || null}
    ></iframe>
  );
};

Iframe.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  height: PropTypes.string
};

Iframe.defaultProps = {
  className: '',
  height: '100%'
};

export default Iframe;
